<template>
  <div class="card">
    <router-link :to="to" @click.native="trackClick">
      <div class="container">
        <div class="column">
          <slot name="product-logo"></slot>
          <h5 class="m-0">{{ title }} <slot name="product-icon"></slot></h5>
        </div>
        <font-awesome-icon class="mr-2 float-right" :icon="['far', 'chevron-right']" :style="{ color: '#19222b' }" />
      </div>
    </router-link>
  </div>
</template>

<script>
import log from '@/services/log';

export default {
  name: 'OtherProductCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    to: {
      type: Object,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
  methods: {
    trackClick() {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.other.${this.category}.${this.to.path}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 6px;
  border: 1px solid rgb(218, 226, 234);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  position: relative;
  margin-bottom: 0.5rem;

  a {
    padding: 16px;
    &:hover {
      text-decoration: none;
    }

    h5 {
      font-size: 16px;
      font-weight: bold;
      color: $primary-dark-text;
      line-height: 20px;
    }
  }
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
}
.column {
  margin-right: 16px;
}
</style>
